import { useMemo, useState } from "react";
import logo_close from "../assets/close-check.png";
import logo_nophoto from "../assets/nophoto.png";
import Reserve from '../components/Reserve';
import "../styles/ObjectViewer.css";

const formatPrice = (price, currency) => {
  if (price === undefined || price === null || price === ""|| price === "0.00") return "-";
  const value = Number(price);
  if (Number.isNaN(value)) return null;

  const currencyCode =
    typeof currency === "string" && /^[a-z]{3}$/i.test(currency.trim())
      ? currency.trim().toUpperCase()
      : "EUR";

  try {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "symbol",
      maximumFractionDigits: 2,
    }).format(value);
  } catch (_) {
    return `${value.toFixed(2)} ${currencyCode}`;
  }
};

const formatDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

function ObjectViewer({ p_key, object, onClose, listName = "Liste" , p_setLightboxImg, p_isProprio, p_onReserved }) {
  const [imageError, setImageError] = useState(false);
  const cover = imageError ? logo_nophoto : object?.imagelink || logo_nophoto;

  const infoRows = useMemo(() => {
    if (!object) return [];
    const rows = [
      { label: "Prix", value: formatPrice(object.price, object.currency) },
      { label: "Boutique", value: object.site },
    ];
    return rows.filter((row) => Boolean(row.value));
  }, [object]);

  if (!object) return null;

  return (
    <div className="objectviewer-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="objectviewer-card" onClick={(e) => e.stopPropagation()}>
        <img src={logo_close} alt="Fermer" onClick={() => onClose()} className="objectviewer-close" />
        <div className="objectviewer-content">
          <div className="objectviewer-media">
            <img
              src={cover}
              alt={object.title || "Aperçu"}
              onError={() => setImageError(true)}
              onClick={() => p_setLightboxImg(object?.imagelink)}
            />
          </div>
          <div className="objectviewer-body">
            <p className="objectviewer-list">Liste : {listName || "Sans nom"}</p>
            <h3 className="objectviewer-title">{object.title || "Sans titre"}</h3>
            {object.description && (
              <p className="objectviewer-description">{object.description}</p>
            )}
            {infoRows.length > 0 && (
              <div className="objectviewer-meta">
                {infoRows.map((row) => (
                  <div key={row.label} className="objectviewer-meta-item">
                    <span className="objectviewer-meta-label">{row.label}</span>
                    <span className="objectviewer-meta-value">{row.value}</span>
                  </div>
                ))}
              </div>
            )}
            {object.reservationid && (
              <div className="objectviewer-reserved" role="status" aria-live="polite">
                <span className="objectviewer-reserved-dot" aria-hidden="true" />
                <span>Cet article est déjà réservé.</span>
              </div>
            )}
            <div className="ui-buttons">
              {(object.affiliateLink || object.link) && (
                <a
                  href={object.affiliateLink || object.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="objectviewer-primary"
                >
                  Voir le produit
                </a>
              )}
              <Reserve
                p_object={object}
                p_key={p_key}
                p_isProprio={p_isProprio}
                p_onReserved={(reservationId) => {
                  if (typeof p_onReserved === "function") {
                    p_onReserved(object.id, reservationId);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ObjectViewer;
